import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/apps/beemo/node_modules/next/dist/client/app-dir/link.js");
